import './Clients.scss';
import {Stack, Container, Carousel, Row, Col, Card} from 'react-bootstrap';
import QuoteImg from '../assets/quote.png';

function Clients({ setactivelink }) {
    const clientsData = [
        { id: 1, userName: 'RS', userTitle:'Ritika Sharma', userSubtitle: '--', text: "Working with Cubetechstudio was a game-changer for our brand. The logo they created perfectly reflects our identity and has helped us stand out in a competitive market. Their design process was smooth, professional, and highly creative." },
        { id: 2, userName: 'SW', userTitle:'Sara Wilsson', userSubtitle: 'Designer, ABI', text: "From our first consultation to the final brand guideline delivery, the team was incredibly attentive and insightful. They understood our vision and transformed it into a bold and memorable brand identity. We couldn’t be happier!" },
        { id: 3, userName: 'AY', userTitle:'Amol Yadav', userSubtitle: 'Director, Ayush Gram', text: "We approached Cubetechstudio for a complete brand refresh, and they delivered beyond expectations. The new logo, color palette, and typography they provided have given our company a fresh, modern look that resonates with our audience." },
        { id: 4, userName: 'AK', userTitle:'Amol Kulkarni', userSubtitle: 'CEO, Eco Energy Solution', text: "Exceptional design sense and flawless execution. What impressed us most was how they combined creativity with strategy. Our brand now looks more cohesive and professional than ever" },
        { id: 5, userName: 'AC', userTitle:'Atul Mayur Crop', userSubtitle: 'Entrepreneur, Atulya Crop Science', text: "We’ve worked with several designers before, but Cubetechstudio truly stood out. Their ability to understand our business and craft a brand identity that tells our story was outstanding. Highly recommended!" },
    ];

    // Duplicate the array for a seamless loop
    const loopedClients = [...clientsData];
    return (
        <Stack setactivelink={setactivelink} id="clients" gap={6} className="client">
            <Container className="py-4">
                <Row className="justify-content-md-center">
                    <Col>
                        <h1 className="section-title">Clients</h1>
                    </Col>
                </Row>

                {/* <div className="scroll-container">
                    <div className="scroll-content"> */}
                        {/* {loopedClients.map((card, index) => (
                            <Card md key={`${card.id}-${index}`}>
                                <Card.Body>
                                    <div className='title-group'>
                                        <div className="user-name">{card.userName}</div>
                                        <div>
                                            <Card.Title>{card.userTitle}</Card.Title>
                                            <Card.Subtitle className="mb-2">{card.userSubtitle}</Card.Subtitle>
                                        </div>
                                    </div>
                                    <Card.Text>
                                        {card.text}
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        ))} */}

                    {/* </div>
                </div> */}

                <Carousel data-bs-theme="dark">
                    {loopedClients.map((card, index) => (
                        <Carousel.Item key={`${card.id}-${index}`}>
                            <Carousel.Caption>
                                <div className="text">
                                {card.text}
                                </div>
                                <div className='title-group'>
                                    <div className="user-name">{card.userName}</div>
                                    <div>
                                        <h6 className="mb-0">{card.userTitle}</h6>
                                        <div className="mb-2">{card.userSubtitle}</div>
                                    </div>
                                </div>
                            </Carousel.Caption>
                        </Carousel.Item>
                    ))}
                </Carousel>
                   
            </Container>
        </Stack>
    );
}

export default Clients;